// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-44c78916] {\n  font-weight: 600;\n  color: #000;\n  font-size: 16px;\n}", ""]);
// Exports
module.exports = exports;
